import { cloneDeep } from 'lodash/fp'

/**
 * Retrieves configuration Object stored in state
 *
 * @method getConfiguration
 * @param  {Object} state Redux state.
 * @return {Object}
 */
export function getConfiguration (state) {
  return cloneDeep(state.config)
}
